import { CSSObject, Theme } from '@core-ui/react-stitch';

const sanitizeHexValue = (hex: string) => hex.replace('#', '%23');

export const getSVGFillColor = (theme: Theme, isBRRedesignEnabled: boolean) => isBRRedesignEnabled ? sanitizeHexValue(theme.color.b2) : sanitizeHexValue(theme.color.gray60);

const getArrowSVG = (theme: Theme, isBRRedesignEnabled: boolean) => `url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='6' viewBox='0 0 9 6'%3E%3Cpath d='M.003 1.533L1.118.529l3.385 3.047L7.89.529l1.114 1.004-4.5 4.05z' style='fill:${getSVGFillColor(theme, isBRRedesignEnabled)};fill-rule:evenodd' /%3E%3C/svg%3E")`;

export const getControlBeforeStyles = (
  theme: Theme,
  isBRRedesignEnabled: boolean
): CSSObject => ({
  content: '""',
  background: `${getArrowSVG(theme, isBRRedesignEnabled)} no-repeat`,
  width: '1.5rem',
  height: '2rem',
  display: 'block',
  position: 'absolute',
  right: '1px',
  top: '1px',
  backgroundPositionX: '2px',
  backgroundPositionY: '18px',
  ...(isBRRedesignEnabled && {
    background: `${getArrowSVG(theme, isBRRedesignEnabled)} no-repeat`,
  }),
});

export default getControlBeforeStyles;
